import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root',
})
export class PaginationService extends MatPaginatorIntl {
  private paginationState: {
    pageIndex: number;
    pageSize: number;
    resultsLength: number;
  } | null = null;

  savePaginationState(
    pageIndex: number,
    pageSize: number,
    resultsLength: number,
  ) {
    this.paginationState = { pageIndex, pageSize, resultsLength };
  }

  getPaginationState() {
    return this.paginationState;
  }

  clearPaginationState() {
    this.paginationState = null;
  }
}
